import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IDropDownView } from "../interfaces/idropdowns";
import { ISelectItem } from "../interfaces/iselectitem";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
/**
 * @whatItDoes A service for performing operations based on drop downs
 *
 * @howToUse To use, inject in to any constructor
 */
@Injectable()
export class DropDownsService extends BaseService {

    /**
     * Constructor for the service
     * @param http
     * @param toastr
     * @param authService Authentication Service
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns an Observable containing the list of drop downs
     */
    getAll(): Observable<IDropDownView[]> {
        return super.get("/api/DropDown").pipe(map((res: any) => res as IDropDownView[]));
    }

    /**
     * Returns an IDropDownView of a particular drop down
     * @param id The id to retrieve the drop down for
     */
    getDropDown(id:number): Observable<IDropDownView> {
        return super.get(`/api/DropDown/${id}`).pipe(map((res: any) => res as IDropDownView));
    }

    /**
     * Returns an IDropDownView of response for the drop down being updated
     * @param dropDown The drop down to update
     */
    update(dropDown: IDropDownView): Observable<IDropDownView> {
        return super.put("/api/DropDown", dropDown).pipe(map((res: any) => res as IDropDownView));
    }

     /**
      * Returns an IDropDownView of response for the drop down being updated
      * @param dropDown The drop down to create
      */
    create(dropDown: IDropDownView): Observable<IDropDownView> {
        return super.post("/api/DropDown", dropDown).pipe(map((res: any) => res as IDropDownView));
    }
}






